<template>
  <div class="payment-complete-page">
    <sub-header-section :pageTitle="$tc('PaymentPage.EditPage.pageTitle')" />

    <complete-pane
      :pageTitle="$tc('PaymentPage.CompletePage.pageTitle')"
      :isReadOnlyPlan="isReadOnlyPlan"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import CompletePane from '@/components/pc/MyPage/CompletePane/CompletePane.vue'
import StoreUtil from '@/store/StoreUtil'

/**
 * クレジットカード情報変更ページ
 */
export default defineComponent({
  name: 'PaymentCompletePage',
  components: {
    SubHeaderSection,
    CompletePane,
  },
  setup() {
    const store = StoreUtil.useStore('ContractInfoStore')
    const { isReadOnlyPlan } = store

    return {
      isReadOnlyPlan,
    }
  },
})
</script>

<style lang="scss" scoped>
.payment-complete-page {
  &__header {
    position: sticky;
    top: 0;
  }
}
</style>
